import React from 'react';

import { InspectionInstructionScreen } from '../../Screens';

const InspectionInstructionContainer = () => {
  return <InspectionInstructionScreen />;
};
export default InspectionInstructionContainer;
